import { normalizePathname } from './config';

/**
 * Tradewing app routes that must never be proxied to Webflow.
 * Any path not matching these prefixes is treated as a Webflow marketing page.
 */
const RESERVED_ROUTE_PREFIXES = [
  '/_next',
  '/admin',
  '/api',
  '/activate',
  '/attendee-registration',
  '/blog',
  '/cart',
  '/community',
  '/companies',
  '/createRoom',
  '/drafts',
  '/events',
  '/get-app',
  '/graphql2',
  '/group-invite',
  '/interaction',
  '/learning',
  '/login',
  '/logout',
  '/me',
  '/meetingRoom',
  '/members',
  '/membership-orders',
  '/memberships',
  '/messages',
  '/morgoth',
  '/my-company',
  '/my-membership',
  '/new-membership',
  '/notifications',
  '/oidc',
  '/poll',
  '/post',
  '/privacy-policy',
  '/programmableRenderer',
  '/question',
  '/reset-password',
  '/search',
  '/site',
  '/sponsors',
  '/terms-and-conditions',
  '/ui',
  '/v1',
  '/virtualEvent',
  '/website-builder',
];

const RESERVED_EXACT_ROUTES = new Set([
  '/favicon.ico',
  '/robots.txt',
  '/sitemap.xml',
]);

export const isReservedTradewingRoute = (pathname: string): boolean => {
  const normalizedPath = normalizePathname(pathname);

  if (RESERVED_EXACT_ROUTES.has(normalizedPath)) {
    return true;
  }

  if (/\.[^/]+$/.test(normalizedPath)) {
    return true;
  }

  return RESERVED_ROUTE_PREFIXES.some(
    (prefix) =>
      normalizedPath === prefix || normalizedPath.startsWith(`${prefix}/`)
  );
};

export const shouldProxyToWebflow = (pathname: string): boolean =>
  !isReservedTradewingRoute(pathname);
